export const liveMetricsData = {
  volume24h: 2847293456,
  openInterest: 892456123,
  activeTraders: 145832,
  aiExecutions: 1247593,
  fundingRate: 0.0123,
  totalTrades: 45234567,
};

export const metricsLabels = [
  { key: 'volume24h', label: '24H Volume', prefix: '$', suffix: '', decimals: 0 },
  { key: 'openInterest', label: 'Open Interest', prefix: '$', suffix: '', decimals: 0 },
  { key: 'activeTraders', label: 'Active Traders', prefix: '', suffix: '', decimals: 0 },
  { key: 'aiExecutions', label: 'AI Executions', prefix: '', suffix: '', decimals: 0 },
  { key: 'fundingRate', label: 'Funding Rate', prefix: '', suffix: '%', decimals: 4 },
  { key: 'totalTrades', label: 'Total Trades', prefix: '', suffix: '', decimals: 0 },
];

export const aiAgentsData = [
  {
    id: 'scalper',
    name: 'AI Scalper',
    description: 'High-frequency momentum trading with sub-second execution on volatility spikes',
    pnl: 234.5,
    winRate: 78,
    riskLevel: 'High',
    riskColor: 'warning',
    status: 'live',
    trades24h: 3421,
    avgHoldTime: '12s',
  },
  {
    id: 'funding-arb',
    name: 'Funding Arb Bot',
    description: 'Automated funding rate arbitrage across perpetual exchanges',
    pnl: 89.2,
    winRate: 92,
    riskLevel: 'Low',
    riskColor: 'neon-green',
    status: 'live',
    trades24h: 156,
    avgHoldTime: '4h',
  },
  {
    id: 'meme-hunter',
    name: 'Meme Hunter',
    description: 'Social sentiment analysis and early entry on viral token movements',
    pnl: 567.8,
    winRate: 65,
    riskLevel: 'Very High',
    riskColor: 'danger',
    status: 'live',
    trades24h: 892,
    avgHoldTime: '45m',
  },
  {
    id: 'prediction-ai',
    name: 'Prediction AI',
    description: 'Machine learning models forecasting market direction with 71% accuracy',
    pnl: 156.3,
    winRate: 71,
    riskLevel: 'Medium',
    riskColor: 'warning',
    status: 'live',
    trades24h: 567,
    avgHoldTime: '6h',
  },
  {
    id: 'whale-tracker',
    name: 'Whale Tracker',
    description: 'On-chain analysis tracking smart money movements and whale wallets',
    pnl: 198.7,
    winRate: 85,
    riskLevel: 'Medium',
    riskColor: 'warning',
    status: 'live',
    trades24h: 234,
    avgHoldTime: '2d',
  },
];

export const featuresData = [
  {
    id: 'perpetual',
    title: 'Perpetual Trading',
    description: 'Fully on-chain perpetual futures with up to 50x leverage and zero slippage',
    icon: 'ri-line-chart-line',
    span: 'col-span-1 md:col-span-2 row-span-1',
  },
  {
    id: 'ai-execution',
    title: 'AI Execution',
    description: 'AI-powered order routing and optimal entry timing across all markets',
    icon: 'ri-brain-line',
    span: 'col-span-1 row-span-1',
  },
  {
    id: 'prediction',
    title: 'Prediction Markets',
    description: 'Decentralized prediction markets on crypto outcomes with instant settlement',
    icon: 'ri-bar-chart-grouped-line',
    span: 'col-span-1 row-span-1',
  },
  {
    id: 'copy-trading',
    title: 'Copy Trading',
    description: 'Follow top-performing AI agents and verified traders with one click',
    icon: 'ri-user-follow-line',
    span: 'col-span-1 row-span-1',
  },
  {
    id: 'hyperevm',
    title: 'HyperEVM',
    description: 'Multi-chain expansion across Ethereum, Solana, Arbitrum, and Base',
    icon: 'ri-links-line',
    span: 'col-span-1 md:col-span-2 row-span-1',
  },
  {
    id: 'vault',
    title: 'Strategy Vault',
    description: 'Automated yield-generating strategies with built-in risk management',
    icon: 'ri-safe-2-line',
    span: 'col-span-1 row-span-1',
  },
];

export const liveTradesData = [
  { pair: 'BTC-PERP', side: 'long', price: 45230.5, size: 2.5, time: '2s ago' },
  { pair: 'ETH-PERP', side: 'short', price: 3124.8, size: 5.0, time: '5s ago' },
  { pair: 'SOL-PERP', side: 'long', price: 142.3, size: 10.0, time: '8s ago' },
  { pair: 'ARB-PERP', side: 'long', price: 0.89, size: 2500.0, time: '12s ago' },
  { pair: 'DOGE-PERP', side: 'short', price: 0.12, size: 50000.0, time: '15s ago' },
  { pair: 'LINK-PERP', side: 'long', price: 14.56, size: 100.0, time: '18s ago' },
  { pair: 'AVAX-PERP', side: 'short', price: 35.2, size: 50.0, time: '21s ago' },
  { pair: 'OP-PERP', side: 'long', price: 2.34, size: 500.0, time: '24s ago' },
  { pair: 'SUI-PERP', side: 'long', price: 1.45, size: 2000.0, time: '28s ago' },
  { pair: 'SEI-PERP', side: 'short', price: 0.56, size: 10000.0, time: '31s ago' },
];

export const developerSnippets = [
  {
    language: 'python',
    label: 'Python SDK',
    code: `import eth_account
from zhisu.exchange import Exchange
from zhisu.info import Info
from zhisu.utils import constants

# 1. Setup credentials
account_address = "0xYourWalletAddress"
private_key = "0xYourPrivateKey..."
account = eth_account.Account.from_key(private_key)

# 2. Initialize clients
base_url = constants.MAINNET_API_URL
info = Info(base_url, skip_ws=True)
exchange = Exchange(account, base_url, account_address=account_address)

# 3. Fetch account state
coin = "BTC"
user_state = info.user_state(account_address)
print(f"Account Margin: {user_state['marginSummary']}")

# 4. Set leverage (10x cross margin)
exchange.update_leverage(leverage=10, coin=coin, is_cross=True)

# 5. Place a limit order
order_type = {"limit": {"tif": "Gtc"}}
result = exchange.order(
    coin=coin,
    is_buy=True,
    sz=0.05,
    px=45230.50,
    order_type=order_type
)
print(f"Order Result: {result}")`,
  },
  {
    language: 'javascript',
    label: 'REST API',
    code: `import axios from 'axios';

const BASE_URL = 'https://api.zhisu.trade';
const MARKET = 'BTC-PERP';

async function fetchMarketData() {
  // Fetch recent trades
  const trades = await axios.get(
    \`\${BASE_URL}/markets/\${MARKET}/trades\`
  );
  console.log('Recent trades:', trades.data[0]);

  // Fetch orderbook snapshot
  const orderbook = await axios.get(
    \`\${BASE_URL}/markets/\${MARKET}/orderbook\`,
    { params: { depth: 50 } }
  );
  console.log('Best bid:', orderbook.data.bids[0]);
  console.log('Best ask:', orderbook.data.asks[0]);

  // Fetch 24h ticker stats
  const ticker = await axios.get(
    \`\${BASE_URL}/markets/\${MARKET}/stats\`
  );
  console.log('24h Volume:', ticker.data.volume);
  console.log('Funding Rate:', ticker.data.fundingRate);
}

fetchMarketData().catch(console.error);`,
  },
  {
    language: 'javascript',
    label: 'WebSocket',
    code: `const ws = new WebSocket(
  'wss://stream.zhisu.trade/v1/market'
);

ws.onopen = () => {
  // Subscribe to real-time tickers
  ws.send(JSON.stringify({
    op: 'subscribe',
    channel: 'tickers',
    symbols: ['BTC-PERP', 'ETH-PERP', 'SOL-PERP']
  }));

  // Subscribe to orderbook depth
  ws.send(JSON.stringify({
    op: 'subscribe',
    channel: 'orderbook',
    symbol: 'BTC-PERP',
    depth: 20
  }));
};

ws.onmessage = (event) => {
  const data = JSON.parse(event.data);

  if (data.channel === 'tickers') {
    console.log(data.symbol, data.price, data.change24h);
  }

  if (data.channel === 'orderbook') {
    console.log('Bid:', data.bids[0]);
    console.log('Ask:', data.asks[0]);
  }
};

ws.onerror = (err) => console.error('WS error:', err);`,
  },
];

export const architectureData = [
  {
    id: 'ai-engine',
    name: 'AI Engine',
    description: 'Neural networks for signal generation, pattern recognition, and predictive modeling',
    icon: 'ri-brain-line',
    color: '#00ff88',
  },
  {
    id: 'liquidity-engine',
    name: 'Liquidity Engine',
    description: 'Deep orderbook aggregation and cross-chain liquidity routing',
    icon: 'ri-water-flash-line',
    color: '#00ccff',
  },
  {
    id: 'execution-engine',
    name: 'Execution Engine',
    description: 'Sub-100ms order execution with MEV protection and optimal routing',
    icon: 'ri-flashlight-line',
    color: '#ffaa00',
  },
  {
    id: 'risk-engine',
    name: 'Risk Engine',
    description: 'Real-time position monitoring, liquidation protection, and portfolio hedging',
    icon: 'ri-shield-check-line',
    color: '#ff5566',
  },
];

export const roadmapData = [
  {
    quarter: 'Q1 2026',
    title: 'Beta Launch',
    items: [
      'AI Agents v1 with 5 strategies',
      'Perpetual Trading Mainnet',
      'WebSocket Real-time API',
      'Cross-chain Bridge Integration',
    ],
    status: 'completed',
  },
  {
    quarter: 'Q2 2026',
    title: 'Mainnet Expansion',
    items: [
      'Prediction Markets Launch',
      'Python & TypeScript SDKs',
      'Mobile Trading App Beta',
      'Institutional API Access',
    ],
    status: 'in-progress',
  },
  {
    quarter: 'Q3 2026',
    title: 'Ecosystem Growth',
    items: [
      'Strategy Vaults Launch',
      'Copy Trading Platform',
      'HyperEVM Multi-chain',
      'Governance Framework',
    ],
    status: 'upcoming',
  },
  {
    quarter: 'Q4 2026',
    title: 'Full Decentralization',
    items: [
      'ZhiSu Token Launch',
      'DAO Governance',
      'Layer 2 Scaling',
      'AI Model Marketplace',
    ],
    status: 'upcoming',
  },
];

export const footerLinks = {
  product: [
    { label: 'Markets', href: '/markets' },
    { label: 'AI Agents', href: '/ai-agents' },
    { label: 'Vaults', href: '/vaults' },
    { label: 'Leaderboard', href: '/leaderboard' },
    { label: 'Fees', href: '/fees' },
    { label: 'Skills', href: '/skills' },
  ],
  developers: [
    { label: 'API Reference', href: '/api-reference' },
    { label: 'SDKs', href: '/sdks' },
  ],
  company: [
    { label: 'About', href: '/about' },
    { label: 'Careers', href: '/careers' },
    { label: 'Press & Media', href: '/press' },
    { label: 'Brand Guidelines', href: '/brand' },
    { label: 'Contact', href: '/contact' },
  ],
  legal: [
    { label: 'Terms of Service', href: '/terms' },
    { label: 'Privacy Policy', href: '/privacy' },
    { label: 'Cookie Policy', href: '/cookies' },
    { label: 'AML Policy', href: '/aml' },
    { label: 'Risk Disclosure', href: '/risk' },
    { label: 'User Agreement', href: '/agreement' },
  ],
};

export const socialLinks = [
  { label: 'X / Twitter', icon: 'ri-twitter-x-line', href: '#' },
  { label: 'Discord', icon: 'ri-discord-line', href: '#' },
  { label: 'Telegram', icon: 'ri-telegram-line', href: '#' },
  { label: 'GitHub', icon: 'ri-github-line', href: '#' },
];